import { isRecord } from 'immutable';

import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';

import {
  type WellnessReportConfiguration,
  type WellnessScore,
  type WellnessScoreRequest,
  WellnessScoreSchema,
} from './wellnessScoreTypes';

// QCS reads only `source` and `filter`; filters taken from the report-configurations store are Immutable Records.
const toRequestReportConfiguration = ({
  source,
  filter,
}: WellnessReportConfiguration): WellnessReportConfiguration => ({
  source,
  filter: isRecord(filter) ? filter.toJS() : filter,
});

export const wellnessScoreApi = {
  async fetchWellnessScore({ type, reportConfigurations, weights }: WellnessScoreRequest): Promise<WellnessScore> {
    const requestUrl = `${getServiceUrl()}/reports/wellness`;
    const body = {
      type,
      reportConfigurations: reportConfigurations.map(toRequestReportConfiguration),
      ...(weights ? { weights } : {}),
    };
    const response = await httpClientInterface.send('POST', requestUrl, body);
    return WellnessScoreSchema.parse(response.data);
  },
};
